import { z } from "zod";

import { ReachabilitySchema } from "./common";

export const ContactPosition = z.enum([
  "owner",
  "vp",
  "director",
  "manager",
  "analyst",
  "administrative",
  "other",
]);

export type ContactPosition = z.infer<typeof ContactPosition>;

export const ContactType = z.enum(["managerial", "legal", "administrative"]);

export type ContactType = z.infer<typeof ContactType>;

export const ContactSchema = ReachabilitySchema.extend({
  name: z.string().max(120).optional(),
  position: ContactPosition.optional(),
  type: ContactType.optional(),
  observation: z.string().max(500).optional(),
}).describe("Named contact with role and reachability.");

export type Contact = z.infer<typeof ContactSchema>;
